module.exports = __webpack_public_path__ + "img/search.8eac1d2c.svg";